import { Col, Row, Space } from 'antd'
import { ButtonActionBar, DropdownMenu, Typography } from 'modules/core/components'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ApprovalKpis, ReleaseStrategies } from './components'
import configuration from 'modules/configuration'
import { connect } from 'react-redux'
import { SolutionOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'

const LiberationStrategyList = ({ fetchStrategiesKpis, strategiesKpis }) => {
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()
  let history = useHistory()

  useEffect(() => {
    setIsLoading(true)
    fetchStrategiesKpis().then(() => setIsLoading(false))
  }, [fetchStrategiesKpis])

  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <ButtonActionBar position="space-between">
          <Space direction="vertical">
            <Typography.Headline level={4} type="primary">
              {t('CONFIG_APPROVALS_TITLE')}
            </Typography.Headline>
            <Typography.Body>{t('CONFIG_APPROVALS_DESCRIPTION')}</Typography.Body>
          </Space>
          <DropdownMenu
            title={t('ACTION_MORE')}
            menu={[
              {
                title: t('ACTION_ACTIVITIES'),
                icon: <SolutionOutlined />,
                onClick: () =>
                  history.push('/configuracion/actividad?type=release_strategy&module=config'),
              },
            ]}
          />
        </ButtonActionBar>
      </Col>
      <Col span={24}>
        <ApprovalKpis data={strategiesKpis} loading={isLoading} />
      </Col>
      <Col span={24}>
        <ReleaseStrategies onRefetchKpis={() => fetchStrategiesKpis()} />
      </Col>
    </Row>
  )
}

const mapStateToProps = (state) => ({
  strategiesKpis: configuration.selectors.getStrategiesKpis(state),
})

const mapDispatchToProps = {
  fetchStrategiesKpis: configuration.actions.fetchStrategiesKpis,
}

export default connect(mapStateToProps, mapDispatchToProps)(LiberationStrategyList)
